import styled from 'styled-components'

export const StyledTableContainer = styled.div`
	& .dx-datagrid-rowsview .cell-colored {
		background-color: ${({ bgColor, isBgColor }) => isBgColor ? bgColor + '!important' : 'initial'};
	}
	`
